import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import {LoginPage, TripDashboard, TripSelection, SignupPage,
  AppLoader, DashboardLayout, ExpensesPage, AddExpensePage, BudgetPage, SettingsPage, NewTrip, ReportsPage, RefundReportIL, RefundReportGlobal, ItineraryPage, ProfilePage} from './pages';
import {UpdateDashboard, UploadUpdate, UpdateHistory} from './pages/Admin';
import { InvitePage } from './pages/InvitePage';

import './index.css';
import './ux/globals.css';
import { RootProvider } from './context/RootProvider';
import {PrivateRoute, AdminRoute} from './components/Routes';

const App: React.FC = () => {
  return (
    <RootProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/invite/:code" element={<InvitePage />} />

          <Route element={<PrivateRoute />}>
            <Route path="/app" element={<AppLoader />} />
            <Route path="/dashboard" element={<TripDashboard />} />
            <Route path="/new-trip" element={<NewTrip />} />
            <Route path="/profile" element={<DashboardLayout />}>
              <Route index element={<ProfilePage />} />
            </Route>
            <Route path="/trip/:tripId" element={<DashboardLayout />}>
              <Route index element={<TripDashboard />} />
              <Route path="expenses" element={<ExpensesPage />} />
              <Route path="add-expense" element={<AddExpensePage />} />
              <Route path="budget" element={<BudgetPage />} />
              <Route path="itinerary" element={<ItineraryPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="reports/refund-report-il" element={<RefundReportIL />} />
              <Route path="reports/refund-report-global" element={<RefundReportGlobal />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
            <Route path="/trips" element={<TripSelection />} />
          </Route>

           {/* Admin Update Routes */}
           <Route element={<AdminRoute />}>
            <Route path="/updates" element={<DashboardLayout />}>
              <Route index element={<UpdateDashboard />} />
              <Route path="upload" element={<UploadUpdate />} />
              <Route path="history" element={<UpdateHistory />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </RootProvider>
  );
};

export default App;